import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTableView = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M0 1C0 0.447716 0.447715 0 1 0H19.0003C19.5526 0 20.0003 0.447715 20.0003 1V8.33348C20.0003 8.88576 19.5526 9.33348 19.0003 9.33348H1C0.447715 9.33348 0 8.88576 0 8.33348V1Z",
			fill: "current"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M0 11.666C0 11.1137 0.447715 10.666 1 10.666H19.0003C19.5526 10.666 20.0003 11.1137 20.0003 11.666V18.9995C20.0003 19.5518 19.5526 19.9995 19.0003 19.9995H1C0.447715 19.9995 0 19.5518 0 18.9995V11.666Z",
			fill: "current"
		})
	]
});
const ForwardRef = forwardRef(SvgTableView);
export { ForwardRef as ReactComponent };
